import React from 'react';
import { Brain } from 'lucide-react';

const METHOD_LABELS = {
  semantic: 'смысл',
  fulltext: 'слова',
  trigram: 'похоже',
  exact_code: 'код',
  prefix_code: 'код',
  ilike: 'подстрока',
  ilike_description: 'подстрока',
  trademark: 'марка',
  trademark_ilike: 'марка',
  trademark_trigram: 'марка ≈',
  importer: 'импортёр',
  importer_trigram: 'импортёр ≈',
  similar: 'похожий',
};

/**
 * Quiet relevance indicator. Only shows the AI-rerank percentage when the
 * reranker actually contributed (≥ 0.1). Method labels move to a tooltip —
 * they don't fight for attention on every row.
 */
export default function RelevanceBadge({ score, methods, rerankerScore }) {
  if (rerankerScore == null || rerankerScore <= 0) {
    return null;
  }
  const pct = Math.round(rerankerScore * 100);
  const methodList = (methods || '')
    .split(',')
    .map(m => m.trim())
    .filter(Boolean)
    .map(m => METHOD_LABELS[m] || m)
    .join(' · ');

  return (
    <span
      className="inline-flex items-center gap-1 px-1.5 h-[18px] rounded text-[10px] font-semibold tabular-nums bg-violet-50 text-violet-700 dark:bg-violet-950/40 dark:text-violet-300"
      title={`AI-реранкинг: ${pct}%${methodList ? ` · методы: ${methodList}` : ''}${score != null ? ` · техн. оценка: ${score.toFixed(3)}` : ''}`}
    >
      <Brain className="w-2.5 h-2.5" />
      {pct}%
    </span>
  );
}
